import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from "@angular/material/button";

export class ConfirmDialogData {
  title: string;
  text: string;
  confirm: string;
  cancel: string;
}
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: [
        MatButton,
        MatDialogClose
    ]
})
export class ConfirmDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
    ) {
    }

    ngOnInit() {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}

